import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useLogoutMutation } from '@shared/generated'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

const STORE_LINKS = {
  android: 'https://play.google.com/store/apps/details?id=com.astor.loyalty.mobile.anvar',
  ios: 'https://apps.apple.com/kz/app/%D0%B0%D0%BD%D0%B2%D0%B0%D1%80/id1599300118',
}

export default function LoyaltyRegisterMessage () {
  const { t: tu } = useTranslation('user')
  const { t: tc } = useTranslation('common')
  const isTablet = useMediaQuery('(max-width: 767px)')
  const [ fetchLogout ] = useLogoutMutation()

  const handleLogout = async () => {
    try {
      await fetchLogout()
      localStorage.removeItem('address-store')
      window.location.href = '/'
    }
    catch (error) {
      console.error('Logout error:', error)
      window.location.href = '/'
    }
  }

  return (
    <div className={styles['loyalty-message']}>
      <p className={styles['loyalty-message__text']}>
        {tu('loyaltyRegister.message')}
      </p>
      <div className={styles['loyalty-message__stores']}>
        <a
          href={STORE_LINKS.android}
          target="_blank"
          rel="noopener noreferrer"
          className={styles['loyalty-message__store-link']}
        >
          <img src="/icons/mobile-app/play-market.svg" alt="Google Play" />
        </a>
        <a
          href={STORE_LINKS.ios}
          target="_blank"
          rel="noopener noreferrer"
          className={styles['loyalty-message__store-link']}
        >
          <img src="/icons/mobile-app/apple.svg" alt="App Store" />
        </a>
      </div>
      <Button
        theme="grey"
        size={isTablet ? 'medium' : 'large'}
        onClick={handleLogout}
        className={styles['loyalty-message__button']}
      >
        {tc('finish')}
      </Button>
    </div>
  )
}
